module.exports = __webpack_public_path__ + "static/media/profile.630ae33a.svg";